import React, { FC, useEffect, useState } from "react";

import InputLabelWrapper from "components/basic/input-label-wrapper/InputLabelWrapper";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { T } from "services/lang/LanguageService";
import { useGetObjectDatasets } from "api/api-hooks/object-dataset-hooks";
import useCurrentCompanyContext from "hooks/useCurrentCompanyContext";
import { AutoCompleteChangeEvent, AutoCompleteCompleteEvent, AutoComplete } from "primereact/autocomplete";
import { DashboardEditorProps } from "components/ComponentTypeTypes";
import { ObjectDatasetConfig } from "./ObjectDatasetConfig";

const ObjectDatasetEditor: FC<DashboardEditorProps<ObjectDatasetConfig>> = ({ config, onConfigChange }) => {
  const [items, setItems] = useState<string[]>([]);
  const companyRef = useCurrentCompanyContext()?.companyReference ?? "";
  const { data, isLoading } = useGetObjectDatasets(companyRef, {
    enabled: !!companyRef,
  });

  useEffect(() => {
    if (data) {
      setItems(
        data.find(d => d.identifier === config.identifier)?.data[0]?.fileNames ?? []
      );
    }
  }, [config.identifier, data]);

  const selectedDataset = data?.find(d => d.identifier === config.identifier);

  const onChange = (e: AutoCompleteChangeEvent | DropdownChangeEvent) => {
    const { value, name } = e.target;
    onConfigChange({ ...config, [name]: value });
  };

  const search = (e: AutoCompleteCompleteEvent) => {
    let files;

    if (!e.query.trim().length) {
      files = [...items];
    } else {
      files = items.filter(item => {
        return item.toLowerCase().includes(e.query.toLowerCase());
      });
    }
    setItems(files);
  };

  return (
    <div className="flex gap-3">
      <InputLabelWrapper labelName={T("label.object-dataset")} col={4}>
        <Dropdown
          options={data ?? []}
          onChange={onChange}
          value={config.identifier}
          optionValue="identifier"
          optionLabel="title"
          name="identifier"
          placeholder={T("select.model")}
          loading={isLoading}
        />
      </InputLabelWrapper>
      {selectedDataset?.type === "HTML" && (
        <InputLabelWrapper labelName={T("word.file")} col={4}>
          <AutoComplete
            suggestions={items}
            completeMethod={search}
            onChange={onChange}
            name="initialFileName"
            inputClassName="w-full"
            value={config.initialFileName}
            placeholder={T("placeholder.write-initial-file-name")}
          />
        </InputLabelWrapper>
      )}
    </div>
  );
};

export default ObjectDatasetEditor;